import type { ReactNode } from 'react';

export const symbol_doorbell: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M503-278.5q10-8.5 12-21.5h-70q2 13 12 21.5t23 8.5q13 0 23-8.5ZM340-320h280q6 0 10.5-4.5T635-335q0-6-4.5-10.5T620-350h-25v-99q0-42.6-24-77.46-24-34.86-66-44.54v-14q0-10.83-7.12-17.92-7.11-7.08-18-7.08-10.88 0-17.88 7.08-7 7.09-7 17.92v14q-42 9.68-66 44.54T365-449v99h-25q-6 0-10.5 4.5T325-335q0 6 4.5 10.5T340-320ZM160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q8.3-6 17.34-9 9.05-3 18.86-3 9.8 0 18.71 3 8.92 3 17.09 9l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220q-24.75 0-42.37-17.63Q160-155.25 160-180Zm60 0h520v-394L480-763 220-574v394Zm260-292Z"
		/>
	</svg>
);
